import styled from "styled-components";

import { FaBars } from "react-icons/fa";

export const IconMenu = styled(FaBars)`
  color: #6c63ff;
  cursor: pointer;
  height: 2rem;
  width: 2rem;
  position: absolute;
  left: 5%;
  top: 5%;
  display: none;

  @media (max-width: 1000px) {
    display: ${({ showMenu }) => (showMenu ? "none" : "block")};
  }
`;
